import { render, staticRenderFns } from "./DetailInsentifManager.vue?vue&type=template&id=3d72a293"
import script from "./DetailInsentifManager.vue?vue&type=script&lang=js"
export * from "./DetailInsentifManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports